export const AdvisorObjectionActionBar = ({ objectionResponse, onSelectAction }) => {
  if (!objectionResponse?.suggested_actions?.length) return null;

  return (
    <div className="border-t border-[#D4AF37]/20 bg-[#fff7e5] px-4 py-4" data-testid="signature-advisor-objection-action-bar">
      <p className="text-[11px] font-bold uppercase tracking-[0.18em] text-[#8b6d16]" data-testid="signature-advisor-objection-action-bar-eyebrow">Quick objection handling</p>
      <div className="mt-3 flex flex-wrap gap-2" data-testid="signature-advisor-objection-action-chip-group">
        {objectionResponse.suggested_actions.map((action) => (
          <button
            className="rounded-full border border-[#D4AF37]/35 bg-white px-3 py-2 text-xs font-semibold text-[#001935] transition hover:bg-[#fff0cc]"
            data-testid={`signature-advisor-objection-action-${action.toLowerCase().replace(/[^a-z0-9]+/g, '-')}`}
            key={action}
            onClick={() => onSelectAction(action)}
            type="button"
          >
            {action}
          </button>
        ))}
      </div>
    </div>
  );
};